const CACHE_PREFIX = "holidays";
const CACHE_VERSION = 1;

function getCacheKey(type, year, region) {
  return `${CACHE_PREFIX}:${CACHE_VERSION}:${type}:${region}:${year}`;
}

function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeCache(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export async function fetchPublicHolidays(year, bundeslandCode) {
  const cacheKey = getCacheKey("public", year, bundeslandCode);
  const cached = readCache(cacheKey);
  if (cached) return cached;

  const res = await fetch(
    `https://feiertage-api.de/api/?jahr=${year}&nur_land=${bundeslandCode}`
  );
  const data = await res.json();

  const holidays = Object.values(data).map(h => h.datum);

  writeCache(cacheKey, holidays);
  return holidays;
}

export async function fetchSchoolHolidays(year, subdivisionCode) {
  const cacheKey = getCacheKey("school", year, subdivisionCode);
  const cached = readCache(cacheKey);

  if (cached) {
    return cached.map(v => ({
      start: new Date(v.start),
      end: new Date(v.end),
    }));
  }

  const from = `${year}-01-01`;
  const to = `${year}-12-31`;

  const res = await fetch(
    `https://openholidaysapi.org/SchoolHolidays?countryIsoCode=DE&subdivisionCode=${subdivisionCode}&languageIsoCode=DE&validFrom=${from}&validTo=${to}`
  );
  const data = await res.json();

  const vacations = data.map(v => ({
    start: v.startDate,
    end: v.endDate,
  }));

  writeCache(cacheKey, vacations);

  return vacations.map(v => ({
    start: new Date(v.start),
    end: new Date(v.end),
  }));
}
